<template>
  <div>
    <div class="seach-pagination-container">
      <div class="search-container">
        <img
            class="text-search"
            src="@/assets/icon/chat-search.svg"
            alt="search"
            height="18"
            width="17"
        >
        <input
            type="text"
            placeholder="ค้นหา"
            v-model="searchText"
            @input="search"
            @keyup.enter="search"
        >
        <img
            class="text-clear"
            v-if="searchText !== ''"
            src="@/assets/icon/chat-clear.svg"
            alt="clear"
            height="13"
            width="13"
            @click="clearSearch()"
        >
      </div>
      <el-pagination
          class="left-pagination"
          layout="prev, pager, next"
          :total="totalItems"
          :page-size="perPage"
          @current-change="setPage"
          :current-page.sync="page"
      ></el-pagination>
    </div>
    <el-table v-loading="loading" id="caregiver-table" :data="caregiversList" style="width: 100%" @row-click="rowClick">
      <el-table-column prop="lastActive" label="แอคทีฟล่าสุด" width="200"></el-table-column>
      <el-table-column prop="id" label="เลขผู้ดูแล" width="100"></el-table-column>
      <el-table-column prop="type" label="ประเภท" width="90"></el-table-column>
      <el-table-column prop="name" label="ชื่อผู้ดูแล" width="185"></el-table-column>
      <el-table-column prop="phone" label="เบอร์โทร" width="145"></el-table-column>
      <el-table-column prop="address" label="สถานที่อยู่" width="120"></el-table-column>
      <el-table-column prop="rating" label="เรทติ้ง" width="70"></el-table-column>
      <el-table-column prop="cases" label="เคส" width="60"></el-table-column>
      <el-table-column prop="shifts" label="เวร" min-width="60"></el-table-column>
    </el-table>
  </div>
</template>

<style lang="scss">
  .el-table td, .el-table th {
    padding: 16px 0;
  }
  i.el-icon-bell {
    color: #339AF0;
  }
</style>

<style lang="scss" scope>
  .seach-pagination-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .search-container {
    display: flex;
    justify-content: center;
    position: relative;
    margin-bottom: 32px;

    input {
      width: 346px;
      height: 40px;
      border-radius: 20px;
      border: solid 1px #dcdfe6;
      background-color: #FFFFFF;
      outline: 0;
      padding: 8px 44px 6px 44px;
      font-family: 'Sukhumvit-Medium';
      font-size: 16px;
      color: #303133;

      &::placeholder {
        font-family: 'Sukhumvit-SemiBold';
        font-size: 16px;
        color: #c0c4cc;
      }
    }

    .text-search {
      position: absolute;
      top: 10px;
      left: 14px;
    }

    .text-clear {
      position: absolute;
      top: 13px;
      right: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>

<script>
export default {
  name: 'CaregiverTable',
  data () {
    return {
      page: 1,
      pageSize: 500,
      searchText: '',
    }
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    totalItems: {
      type: Number,
      required: true,
    },
    caregiversList: {
      type: Array,
      required: true,
    },
  },
  methods: {
    search () {
      this.$emit('search', this.searchText)
    },
    rowClick (rowItem, column, event) {
      this.$router.push({ name: 'CaregiverDetail', params: { id: rowItem.id }, query: { tab: 'caregiverinfoTab' } })
    },
    setPage (val) {
      this.page = val
      this.$emit('page', this.page)
    },
    clearSearch () {
      this.searchText = ''
      this.$emit('search', this.searchText)
    },
  },
}
</script>
